<template>
  <section class="home-news g-section">
    <div class="g-container">
      <div class="section-head">
        <h2>行业新闻</h2>
        <p>了解保函行业最新政策与动态</p>
      </div>

      <div v-if="newsList.length" class="news-grid">
        <article
          v-for="(item, index) in newsList"
          :key="item.id || index"
          class="news-card g-card"
          @click="toDetail(item.id)"
        >
          <div class="news-img">
            <img :src="item.url" :alt="item.remark" />
          </div>
          <div class="news-body">
            <div class="news-date">
              <i class="dot"></i>
              {{ item.createTime }}
            </div>
            <h3 class="news-title">{{ item.remark }}</h3>
            <div class="news-read">阅读全文 →</div>
          </div>
        </article>
      </div>

      <div v-else class="g-empty">
        <img src="@/assets/noData.png" />
        <p>暂无新闻</p>
      </div>
    </div>
  </section>
</template>

<script>
import { getInfo, getInfoByToken } from '@/lib/api/index'

export default {
  name: 'HomeNews',
  data () { return { newsList: [] } },
  created () {
    const fn = localStorage.getItem('token') ? getInfoByToken : getInfo
    fn().then((res) => {
      if (res.code === 200) this.newsList = (res.data && res.data[1]) || []
    })
  },
  methods: {
    toDetail (id) {
      this.$router.push({ path: '/detail', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.section-head {
  text-align: center;
  margin-bottom: 40px;

  h2 {
    margin: 0 0 8px;
    font-size: 32px;
    font-weight: 700;
    color: @text-strong;
  }
  p {
    margin: 0;
    color: @text-muted;
    font-size: 14px;
  }
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.news-card {
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  transition: all @duration-base @ease-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: @shadow-lg;
  }
}

.news-img {
  aspect-ratio: 16/10;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform @duration-slow @ease-out;
  }
}

.news-card:hover .news-img img {
  transform: scale(1.06);
}

.news-body {
  padding: 20px 22px 24px;

  .news-date {
    display: flex;
    align-items: center;
    gap: 6px;
    color: @text-muted;
    font-size: 12px;
    margin-bottom: 10px;

    .dot {
      width: 6px; height: 6px;
      border-radius: 50%;
      background: @primary;
    }
  }

  .news-title {
    margin: 0 0 14px;
    font-size: 16px;
    font-weight: 600;
    color: @text-strong;
    line-height: 1.5;
    .multi-ellipsis(2);
  }

  .news-read {
    color: @primary;
    font-size: 13px;
    font-weight: 600;
  }
}
</style>
